
import { ref } from "vue";
import zhCn from "element-plus/lib/locale/lang/zh-cn";
import { Options, Vue } from "vue-class-component";
import { compare, dateConversion, getLocalProject } from "@/utils";
import * as echarts from "echarts";
import {
  dispatchDeepMemoryDeviceOptions,
  dispatchDeepMemorySceneOptions,
  dispatchDeepMemoryTrend,
  dispatchDeepMemoryDateOptions,
  dispatchDeepMemorySubSceneOptions,
  dispatchDeepMemoryRecordList,
  dispatchDeepMemoryCircleChart,
  dispatchDeepMemoryData,
  dispatchDeepMemoryDataCread,
  dispatchDeepMemoryDataCreadOld,
  dispatchDeepFind,
  dispatchDeepMemreportData,
  dispatchDeepMemoryDownLoad,
  dispatchDeepMemoryUobject,
  dispatchDeepMemoryUobjectTrend,
  dispatchDeepMemoryLlmList,
} from "@/store/performance/actions";

import { store } from "@/store";
import {
  readGetDeepMemorySceneOption,
  readGetDeepMemreportDownload,
  readGetDeepMemoryDeviceOption,
  readGetDeepMemoryTrend,
  readGetDeepMemoryLlmList,
  readGetDeepMemorySubsceneOption,
  readGetDeepMemoryDateOption,
  readGetDeepMemoryRecondList,
  readGetDeepMemoryCircleChart,
  readGetDeepMemoryData,
  readGetDeepMemoryDataCread,
  readGetDeepMemoryDataCreadOld,
  readDeepFind,
  readGetDeepMemreportData,
  readGetDeepMemoryUobject,
  readGetDeepMemoryUobjectTrend,
} from "@/store/performance/getters"; //引入仓库接口

import { toRaw } from "@vue/reactivity";
import { dispatchGetDeviceSpecs } from "@/store/device/actions";
import { readDeviceSpecs } from "@/store/device/getters";
import { readUserProfile } from "@/store/main/getters";
import { readMyProjects, readProjectScenes } from "@/store/project/getters";
import { dispatchGetProjectScenes } from "@/store/project/actions";
import { ElMessage } from "element-plus";
import { dispatchGetSimpleScripts } from "@/store/task/actions";
import { readSimpleScriptList } from "@/store/task/getters";
import { color } from "html2canvas/dist/types/css/types/color";
import { number, version } from "echarts/core";

export default class ProjectOverview extends Vue {
  public localProject = Number(getLocalProject());
  public uObjectLoading = false;
  public uObjectTrendLoading = false;
  public memoryLltPage = 1;
  public memoryLltSize = 10;
  public get details_list() {
    let list: any = [];
    list = [
      { label: "名称", prop: "name" },
      { label: "类型", prop: "type" },
      { label: "size", prop: "size" },
    ];

    return list;
  }
  public get memoryLltList() {
    let list = readGetDeepMemoryLlmList(store).results;
    list?.forEach((v) => {
      v.newTime = dateConversion(v.time);
    });
    return list;
  }
  public echartShow = true;
  public get deepMemreportData() {
    return readGetDeepMemreportData(store);
  }
  public get objectTrend() {
    return readGetDeepMemoryUobjectTrend(store);
  }

  public get deepMemreportDataCread() {
    let list = [];

    readGetDeepMemoryDataCread(store)?.func_list?.new?.forEach((v, index) => {
      v.deviation1 =
        v.size - readGetDeepMemoryDataCread(store).func_list.old[index].size;
    });
    list = readGetDeepMemoryDataCread(store).func_list?.new;

    return list;
  }
  public get deepMemreportDataCreadOld() {
    let list = [];

    readGetDeepMemoryDataCreadOld(store)?.func_list?.new?.forEach(
      (v, index) => {
        v.deviation1 =
          v.size -
          readGetDeepMemoryDataCreadOld(store).func_list.old[index].size;
      }
    );
    list = readGetDeepMemoryDataCreadOld(store).func_list?.new;

    return list;
  }
  public num = -1;
  public type(item) {
    if (this.localProject == 12 || this.localProject == 48) {
      if (item == 0) {
        return "memreport";
      }
      if (item == 1) {
        return "obj";
      } else {
        return "vedio";
      }
    } else {
      if (item == 0) {
        return "obj";
      }
    }
  }
  public tableRowClassName(row) {
    let colorNum = "";
    if (row.row.is_add === true) {
      colorNum = "red";
    }
    if (row.row.is_delete === true) {
      colorNum = "#00b050";
    } else if (row.row.is_add === false && row.row.is_delete == false) {
      colorNum = "#606266";
    }
    return { color: colorNum, height: "40px" };
  }
  public tabsData = [
    {
      name: "memreport",
      form: {
        device: 0,
        scene: "",
        date: [],
        subScene: [],
        testDevice: [],
        testScene: [],
        memoryDate: "",
        memoryDevice: "",
        memoryScene: "",
        memorySubscene: "",
        memoryOldDate: "",
        memoryOldDevice: "",
        memoryOldScene: "",
        memoryOldSubscene: "",
        inputValue: "",
        type: "",
        pick: [],
      },
    },
    {
      name: "对象内存",

      form: {
        device: 0,
        scene: "",
        date: [],
        subScene: [],
        testDevice: [],
        testScene: [],
        memoryDate: "",
        memoryDevice: "",
        memoryScene: "",
        memorySubscene: "",
        memoryOldDate: "",
        memoryOldDevice: "",
        memoryOldScene: "",
        memoryOldSubscene: "",
        inputValue: "",
        pick: [],
      },
    },
    {
      name: "音频内存",
      form: {
        device: 0,
        scene: "",
        date: [],
        subScene: [],
        testDevice: [],
        testScene: [],
        memoryDate: "",
        memoryDevice: "",
        memoryScene: "",
        memorySubscene: "",
        memoryOldDate: "",
        memoryOldDevice: "",
        memoryOldScene: "",
        memoryOldSubscene: "",
        inputValue: "",
        pick: [],
      },
    },
  ];

  public allTableLoading = false;
  public currentPage = 1;
  public MemoryData = {
    deviceList: [],
    sceneList: [],
    dateList: [],
    subsceneList: [],
    recondList: {
      list: [],
    },
  };
  public async typeChange(i) {
    let form: any = {};
    form = this.tabsData[i].form;
    let type = this.type(i);
    let date = form.memoryDate.split(" ")[0];
    let version = form.memoryDate.split(" ")[1].split("V")[1];
    let oldDate = form.memoryOldDate.split(" ")[0];
    let oldVersion = form.memoryOldDate.split(" ")[1].split("V")[1];
    this.page = 1;
    this.size = 10;
    this.course_input = "";
    await dispatchDeepMemreportData(store, {
      project: this.localProject,
      date: date,
      device_id: Number(form.memoryDevice),
      scene_id: Number(form.memoryScene),
      sub_scene: "",
      version: version,
      old_date: oldDate,
      old_device_id: Number(form.memoryOldDevice),
      old_scene_id: Number(form.memoryOldScene),
      old_sub_scene: "",
      old_version: oldVersion,
      class_name: form.type,
      search: this.course_input,
      page: this.page,
      size: this.size,
      order: "-size",
    });

    this.oreder = "-size";
    this.$nextTick(() => {
      (this.$refs.tableList as any).sort("size", "descending");
    });
    this.id_test = this.deepMemreportData.id_test;
    this.old_test = this.deepMemreportData.old_test;
  }
  public chineseNames(item) {
    if (item == "name") {
      return "名称";
    }
    if (item == "size") {
      return "内存(KB)";
    }
    if (item == "resolution") {
      return "分辨率";
    }
    if (item === "format") {
      return "格式";
    }
    if (item === "size_ondisk") {
      return "存储大小";
    }
    if (item === "mips") {
      return "MIP";
    }
    if (item === "resolution_ondisk") {
      return "存储分辨率";
    }
    if (item === "lod_group") {
      return "LOD Group";
    }
    if (item === "streaming") {
      return "Streaming";
    }
    if (item === "usage_count") {
      return "使用次数";
    }
    if (item === "type") {
      return "Type";
    }
    if (item === "length") {
      return "Length";
    }
    if (item === "rate_scale") {
      return "RateScale";
    }
    if (item === "num_curves") {
      return "NumCurves";
    }
    if (item === "translation_format") {
      return "TranslationFormat";
    }
    if (item === "rotation_format") {
      return "RotationFormat";
    }
    if (item === "scale_format") {
      return "ScaleFormat";
    }
    if (item == "res_exc_size") {
      return "ResExcSize";
    }
    if (item == "full_name") {
      return "full_name";
    }
  }
  public fullNameShow(item) {
    if (
      item === "Texture" ||
      item === "Particle" ||
      item == "StaticMesh" ||
      item == "SkeletalMesh" ||
      item == "StaticMeshComponent" ||
      item == "Level" ||
      item == "Animation"
    ) {
      return true;
    } else {
      return false;
    }
  }
  public inputColor = "";
  public changeList = [];
  public async submit(form, i) {
    // let form: any = {};
    // form = this.tabsData[i].form;
    let type = this.type(i);

    let date = form.memoryDate.split(" ")[0];
    let version = form.memoryDate.split(" ")[1].split("V")[1];
    let oldDate = form.memoryOldDate.split(" ")[0];
    let oldVersion = form.memoryOldDate.split(" ")[1].split("V")[1];
    this.num += 1;
    await dispatchDeepFind(store, {
      project: this.localProject,
      type: type,
      // date:date,
      version: version,
      scene: form.memoryScene == "" ? "" : Number(form.memoryScene),
      device: form.memoryDevice == "" ? "" : Number(form.memoryDevice),
      inside_scene: form.memorySubscene,
      // old_date:oldDate,
      old_version: oldVersion,
      old_scene: form.memoryOldScene == "" ? "" : Number(form.memoryOldScene),
      old_device:
        form.memoryOldDevice == "" ? "" : Number(form.memoryOldDevice),
      old_inside_scene: form.memoryOldSubscene,
      name: form.inputValue,
    });
    if (readDeepFind(store).length != 0) {
      this.inputColor = "inputYellow";
    } else {
      this.inputColor = "inputWhite";
    }

    this.changeList.push(readDeepFind(store));
    if (this.num == 0) {
      this.changeList[0]?.forEach((v) => {
        (this.$refs.table as any).toggleRowExpansion(v, true);
      });
      if (this.changeList[0].length != 0) {
        this.$nextTick(() => {
          if (document.getElementById(this.changeList[0][0]?.id) != null) {
            document.getElementById(
              this.changeList[0][0]?.id
            ).style.backgroundColor = "yellow";
            document.getElementById(this.changeList[0][0]?.id).scrollIntoView();
          }
          if (document.getElementById(this.changeList[0][0]?.id + 1) != null) {
            document.getElementById(
              this.changeList[0][0]?.id + 1
            ).style.backgroundColor = "yellow";

            document
              .getElementById(this.changeList[0][0]?.id + 1)
              .scrollIntoView();
          }
        });
      }
    } else {
      this.changeList[this.num - 1]?.forEach((v) => {
        (this.$refs.table as any).toggleRowExpansion(v, false);
      });
      this.changeList[this.num]?.forEach((v) => {
        (this.$refs.table as any).toggleRowExpansion(v, true);
      });

      if (this.changeList[this.num]?.length != 0) {
        this.$nextTick(() => {
          if (
            document.getElementById(this.changeList[this.num][0].id) != null
          ) {
            document.getElementById(
              this.changeList[this.num][0].id
            ).style.backgroundColor = "yellow";
            document
              .getElementById(this.changeList[this.num][0].id)
              .scrollIntoView();
          }
          if (
            document.getElementById(this.changeList[this.num][0].id + 1) != null
          ) {
            document.getElementById(
              this.changeList[this.num][0].id + 1
            ).style.backgroundColor = "yellow";
            document
              .getElementById(this.changeList[this.num][0].id + 1)
              .scrollIntoView();
          }
        });
      }
      if (this.changeList[this.num - 1]?.length != 0) {
        this.$nextTick(() => {
          if (
            document.getElementById(this.changeList[this.num - 1][0].id) != null
          ) {
            document.getElementById(
              this.changeList[this.num - 1][0].id
            ).style.backgroundColor = "#fff";
          }
          if (
            document.getElementById(this.changeList[this.num - 1][0].id + 1) !=
            null
          ) {
            document.getElementById(
              this.changeList[this.num - 1][0].id + 1
            ).style.backgroundColor = "#fff";
          }
        });
      }
    }
  }
  public object_device = "";
  public object_scene = "";
  public async contrast(form, i) {
    this.memoryLoading = true;
    this.allTableLoading = true;
    this.uObjectLoading = true;
    this.uObjectTrendLoading = true;
    this.course_input = "";
    let type = this.type(i);
    let date = "";
    let version = "";
    let oldDate = "";
    let oldVersion = "";

    if (form.memoryDate != "") {
      date = form.memoryDate.split(" ")[0];
      version = form.memoryDate.split(" ")[1].split("V")[1];
    }
    if (form.memoryOldDate != "") {
      oldDate = form.memoryOldDate.split(" ")[0];
      oldVersion = form.memoryOldDate.split(" ")[1].split("V")[1];
    }

    await dispatchDeepMemoryCircleChart(store, {
      project: this.localProject,
      date: date,
      device_id: Number(form.memoryDevice),
      scene_id: Number(form.memoryScene),
      sub_scene: form.memorySubscene ? form.memorySubscene : "",
      version: version,
      old_date: oldDate,
      old_device_id: Number(form.memoryOldDevice),
      old_scene_id: Number(form.memoryOldScene),
      old_sub_scene: form.memoryOldSubscene ? form.memoryOldSubscene : "",
      old_version: oldVersion,
      type: type,
    });
    await this.cilcrt;

    await this.drawModular(i);
    if (this.localProject == 12 && i == 0) {
      await dispatchDeepMemoryUobject(store, {
        project: this.localProject,
        date: date,
        device_id: Number(form.memoryDevice),
        scene_id: Number(form.memoryScene),
        sub_scene: form.memorySubscene ? form.memorySubscene : "",
        version: version,
        old_date: oldDate,
        old_device_id: Number(form.memoryOldDevice),
        old_scene_id: Number(form.memoryOldScene),
        old_sub_scene: form.memoryOldSubscene ? form.memoryOldSubscene : "",
        old_version: oldVersion,
      });
      this.objectName = "first";
      await dispatchDeepMemoryUobjectTrend(store, {
        project: this.localProject,

        device_id: Number(form.memoryDevice),
        scene_id: Number(form.memoryScene),
      });

      this.drawObjcetsizeTrend(
        this.deviceOptions.filter((v) => v.device_id == form.memoryDevice)[0]
          .device_id__model__name,
        this.sceneOptions.filter((v) => v.scene_id == form.memoryScene)[0]
          .scene_id__chinese
      );
      this.uObjectTrendLoading = false;
    }
    this.uObjectLoading = false;
    this.memoryLoading = false;
    if (type != "memreport") {
      if (this.localProject != 34) {
        await dispatchDeepMemoryData(store, {
          project: this.localProject,
          type: type,
          date: date,
          version: version,
          scene: form.memoryScene == "" ? "" : Number(form.memoryScene),
          device: form.memoryDevice == "" ? "" : Number(form.memoryDevice),
          inside_scene: form.memorySubscene,
          depth: 0,
          name: "",
          old_date: oldDate,
          old_version: oldVersion,
          old_scene:
            form.memoryOldScene == "" ? "" : Number(form.memoryOldScene),
          old_device:
            form.memoryOldDevice == "" ? "" : Number(form.memoryOldDevice),
          old_inside_scene: form.memoryOldSubscene,
          filter: "all",
        });
        await this.memoryTable;
      } else {
        await dispatchDeepMemoryDataCread(store, {
          project: this.localProject,
          type: type,
          date: date,
          version: version,
          scene: form.memoryScene == "" ? "" : Number(form.memoryScene),
          device: form.memoryDevice == "" ? "" : Number(form.memoryDevice),
          inside_scene: form.memorySubscene,
          depth: 0,

          old_date: oldDate,
          old_version: oldVersion,
          old_scene:
            form.memoryOldScene == "" ? "" : Number(form.memoryOldScene),
          old_device:
            form.memoryOldDevice == "" ? "" : Number(form.memoryOldDevice),
          old_inside_scene: form.memoryOldSubscene,
          name: "",
        });
      }
    } else {
      this.nameList = this.cilcrt.map((v) => v.name);
      form.type = this.nameList[0];
      this.size = 10;
      this.page = 1;
      await dispatchDeepMemreportData(store, {
        project: this.localProject,
        date: date,
        device_id: Number(form.memoryDevice),
        scene_id: Number(form.memoryScene),
        sub_scene: "",
        version: version,
        old_date: oldDate,
        old_device_id: Number(form.memoryOldDevice),
        old_scene_id: Number(form.memoryOldScene),
        old_sub_scene: "",
        old_version: oldVersion,
        class_name: form.type,
        search: this.course_input,
        page: this.page,
        size: this.size,
        order: "-size",
      });
      this.oreder = "-size";
      // this.$nextTick(() => {
      //   (this.$refs.tableList as any).sort("size", "descending");
      // });
    }
    this.id_test = this.deepMemreportData.id_test;
    this.old_test = this.deepMemreportData.old_test;

    // await this.memoryTable;
    this.allTableLoading = false;
  }
  public getNum(item, item1) {
    let num = "";
    let color = "";
    if (item1) {
      item = Number(item);
      item1 = Number(item1);

      if (item > item1) {
        num = "(+" + Math.abs(item - item1).toFixed(1) + ")";
        color = "red";
      }
      if (item < item1) {
        num = "(-" + Math.abs(item - item1).toFixed(1) + ")";
        color = "#00b050";
      }
      if (item == item1) {
        num = "";
        color = "#606266";
      }
    } else {
      if (item1 == 0) {
        num = "(0)";
        color = "#606266";
      } else {
        num = "(+" + Math.abs(item - 0).toFixed(1) + ")";
        color = "red";
      }
    }
    return [num, color];
  }
  public oreder = "-size";
  public memoryLoading = false;
  public async textChange(form, item, i) {
    this.allTableLoading = true;
    // let form: any = {};
    // form = this.tabsData[i].form;
    let type = this.type(i);
    let date = "";
    let version = "";
    let oldDate = "";
    let oldVersion = "";
    if (form.memoryDate != "") {
      date = form.memoryDate.split(" ")[0];
      version = form.memoryDate.split(" ")[1].split("V")[1];
    }
    if (form.memoryOldDate != "") {
      oldDate = form.memoryOldDate.split(" ")[0];
      oldVersion = form.memoryOldDate.split(" ")[1].split("V")[1];
    }

    await dispatchDeepMemoryData(store, {
      project: this.localProject,
      type: type,
      date: date,
      version: version,
      scene: form.memoryScene == "" ? "" : Number(form.memoryScene),
      device: form.memoryDevice == "" ? "" : Number(form.memoryDevice),
      inside_scene: form.memorySubscene,
      depth: 0,
      name: "",
      old_date: oldDate,
      old_version: oldVersion,
      old_scene: form.memoryOldScene == "" ? "" : Number(form.memoryOldScene),
      old_device:
        form.memoryOldDevice == "" ? "" : Number(form.memoryOldDevice),
      old_inside_scene: form.memoryOldSubscene,
      filter: item,
    });
    await this.memoryTable;
    this.allTableLoading = false;
  }
  public get memoryTable() {
    this.leftAllTable = readGetDeepMemoryData(store)?.new;
    return this.leftAllTable;
  }
  // public form={
  //   device:'',
  //   scene:'',
  //   date:'',
  //   subScene:'',
  //   testDevice:'',
  //   testScene:''
  // }
  public merShow = true;
  public tableMerShow(item) {
    if (item?.length > 0) {
      this.merShow = true;
    } else {
      this.merShow = false;
    }
  }
  public async sort_change(column) {
    let form: any = {};

    form = this.tabsData[this.activeName].form;
    let type = this.type(this.activeName);
    let data = JSON.parse(JSON.stringify(column));
    let date = "";
    let version = "";
    let oldDate = "";
    let oldVersion = "";
    if (form.memoryDate != "") {
      date = form.memoryDate.split(" ")[0];
      version = form.memoryDate.split(" ")[1].split("V")[1];
    }
    if (form.memoryOldDate != "") {
      oldDate = form.memoryOldDate.split(" ")[0];
      oldVersion = form.memoryOldDate.split(" ")[1].split("V")[1];
    }

    if (data.order == "descending") {
      this.oreder = "-" + data.column.rawColumnKey;
      //          dispatchDeepMemreportData(store, {
      //   project: this.localProject,
      //   date: date,
      //   device_id: Number(form.memoryDevice),
      //   scene_id: Number(form.memoryScene),
      //   sub_scene: '',
      //   version: version,
      //   old_date: oldDate,
      //   old_device_id: Number(form.memoryOldDevice),
      //   old_scene_id: Number(form.memoryOldScene),
      //   old_sub_scene: '',
      //   old_version: oldVersion,
      //   class_name:form.type,
      //   search:'',
      //   page:this.page,
      //   size:this.size,
      //   order:'-'+data.column.label
      // });
    }
    if (data.order == "ascending") {
      this.oreder = data.column.rawColumnKey;
    }
    await dispatchDeepMemreportData(store, {
      project: this.localProject,
      date: date,
      device_id: Number(form.memoryDevice),
      scene_id: Number(form.memoryScene),
      sub_scene: "",
      version: version,
      old_date: oldDate,
      old_device_id: Number(form.memoryOldDevice),
      old_scene_id: Number(form.memoryOldScene),
      old_sub_scene: "",
      old_version: oldVersion,
      class_name: form.type,
      search: this.course_input,
      page: this.page,
      size: this.size,
      order: this.oreder,
    });
    this.id_test = this.deepMemreportData.id_test;
    this.old_test = this.deepMemreportData.old_test;
  }
  public colors = [
    "#5470c6",
    "#91cc75",
    "#fac858",
    "#ee6666",
    "#73c0de",
    "#3ba272",
    "#fc8452",
    "#935bab",
    "#d872bc",
    "#5470c6",
  ];
  public text(num) {
    let text = "";
    let color = "";
    if (!isNaN(num)) {
      if (num > 0) {
        text = "+" + num;
        color = "red";
      } else if (num < 0) {
        text = num;
        color = "#00b050";
      } else {
        text = "0";
        color = "#606266";
      }
    } else {
      text = num;
      color = "#606266";
    }
    return [text, color];
  }
  public cellStyle({ row, column, rowIndex, columnIndex }) {
    //指定坐标rowIndex ：行，columnIndex ：列
    // this.getTableColor(row.depth)
    // console.log(columnIndex)
    if (columnIndex === 0) {
      return {
        background: this.colors[rowIndex],
        color: "#fff",
        fontWeight: "bold",
      }; //rgb(105,0,7)
    }
    // return "background:" + this.getTableColor(row.depth); //rgb(105,0,7)
  }
  public id_test = 0;
  public old_test = 0;
  public look_name = "";
  public async look(form, item, i) {
    document.getElementById("memoryScrol").scrollIntoView();
    this.memoryLoading = true;
    this.allTableLoading = true;
    this.course_input = "";

    // let form: any = res
    // if(this,this.localProject==34){
    //  form=
    // }else{
    //   form = this.tabsData[i].form;
    // }
    this.uObjectLoading = true;
    this.uObjectTrendLoading = true;
    let type = this.type(i);
    this.look_name = item.date_version + "-" + item.device + "-" + item.scene;

    form.memoryDevice = this.deviceOptions.filter(
      (v) => v.device_id__model__name === item.device
    )[0].device_id;
    form.memoryScene = this.sceneOptions.filter(
      (v) => v.scene_id__chinese == item.scene
    )[0].scene_id;
    form.memoryDate = item.params.date_version;
    form.memoryOldDate = item.old_params.date_version;
    form.memorySubscene = item.sub_scene;
    form.memoryOldDevice = item.old_params.device_id;
    form.memoryOldScene = item.old_params.scene_id;
    form.memoryOldSubscene = item.old_params.sub_scene;

    await dispatchDeepMemoryCircleChart(store, {
      project: this.localProject,
      date: item.params.date,
      device_id: Number(item.params.device_id),
      scene_id: Number(item.params.scene_id),
      sub_scene: item.params.sub_scene ? item.params.sub_scene : "",
      version: item.params.game_version,
      old_date: item.old_params.date,
      old_device_id: Number(item.old_params.device_id),
      old_scene_id: Number(item.old_params.scene_id),
      old_sub_scene: item.old_params.sub_scene ? item.old_params.sub_scene : "",
      old_version: item.old_params.game_version,
      type: type,
    });
    await this.cilcrt;
    if (this.localProject == 12 && i == 0) {
      await dispatchDeepMemoryUobject(store, {
        project: this.localProject,
        date: item.params.date,
        device_id: Number(item.params.device_id),
        scene_id: Number(item.params.scene_id),
        sub_scene: item.params.sub_scene ? item.params.sub_scene : "",
        version: item.params.game_version,
        old_date: item.old_params.date,
        old_device_id: Number(item.old_params.device_id),
        old_scene_id: Number(item.old_params.scene_id),
        old_sub_scene: item.old_params.sub_scene
          ? item.old_params.sub_scene
          : "",
        old_version: item.old_params.game_version,
      });
      this.uObjectLoading = false;
      this.objectName = "first";
      await dispatchDeepMemoryUobjectTrend(store, {
        project: this.localProject,

        device_id: Number(item.params.device_id),
        scene_id: Number(item.params.scene_id),
      });

      this.drawObjcetsizeTrend(item.device, item.scene);
      this.uObjectTrendLoading = false;
    }
    if (type === "memreport") {
      this.nameList = this.cilcrt.map((v) => v.name);
      if (this.nameList.indexOf("All") != -1) {
        this.nameList.splice(this.nameList.indexOf("All"), 1);
      }
      form.type = this.nameList[0];
      this.size = 10;
      this.page = 1;
      await dispatchDeepMemreportData(store, {
        project: this.localProject,
        date: item.params.date,
        device_id: Number(item.params.device_id),
        scene_id: Number(item.params.scene_id),
        sub_scene: item.params.sub_scene ? item.params.sub_scene : "",
        version: item.params.game_version,
        old_date: item.old_params.date,
        old_device_id: Number(item.old_params.device_id),
        old_scene_id: Number(item.old_params.scene_id),
        old_sub_scene: item.old_params.sub_scene
          ? item.old_params.sub_scene
          : "",
        old_version: item.old_params.game_version,
        class_name: form.type,
        search: this.course_input,
        page: this.page,
        size: this.size,
        order: "-size",
      });
      this.oreder = "-size";
      this.id_test = this.deepMemreportData.id_test;
      this.old_test = this.deepMemreportData.old_test;
      // this.$nextTick(() => {
      //   (this.$refs.tableList as any).sort("size", "descending");
      // });
    }
    await this.drawModular(i);

    this.memoryLoading = false;
    if (type != "memreport") {
      form.type = "";
      this.tableMerShow(this.tableThead(form.type));

      if (this.localProject != 34) {
        await dispatchDeepMemoryData(store, {
          project: this.localProject,
          type: type,
          date: item.params.date,
          version: item.params.game_version,
          scene: Number(item.params.scene_id),
          device: Number(item.params.device_id),
          inside_scene: item.params.sub_scene,
          depth: 0,
          name: "",
          old_date: item.old_params.date,
          old_version: item.old_params.game_version,
          old_scene: Number(item.old_params.scene_id),
          old_device: Number(item.old_params.device_id),
          old_inside_scene: item.old_params.sub_scene,
          filter: "all",
        });

        await this.memoryTable;
      } else {
        await dispatchDeepMemoryDataCread(store, {
          project: this.localProject,
          type: type,
          date: item.params.date,
          version: item.params.game_version,
          scene: Number(item.params.scene_id),
          device: Number(item.params.device_id),
          inside_scene: item.params.sub_scene,
          depth: 0,

          old_date: item.old_params.date,
          old_version: item.old_params.game_version,
          old_scene: Number(item.old_params.scene_id),
          old_device: Number(item.old_params.device_id),
          old_inside_scene: item.old_params.sub_scene,
          name: "",
        });
      }
    }

    this.allTableLoading = false;
  }
  public get uobjectData() {
    return readGetDeepMemoryUobject(store);
  }
  public tabsdis = true;
  public tableWidth(item) {
    if (item == "name") {
      return 450;
    }
    if (item == "size") {
      return 150;
    }
    if (
      item == "resolution_ondisk" ||
      item == "resolution" ||
      item == "size_ondiskt" ||
      item == "res_exc_size"
    ) {
      return 150;
    }
    if (item == "lod_group") {
      return 200;
    }
  }
  public g = [];
  public async load(
    row: any,
    treeNode: unknown,
    resolve: (date: any[]) => void
  ) {
    let form = this.tabsData[1].form;
    let date = "";
    let version = "";
    let oldDate = "";
    let oldVersion = "";

    if (form.memoryDate != "") {
      date = form.memoryDate.split(" ")[0];
      version = form.memoryDate.split(" ")[1].split("V")[1];
    }
    if (form.memoryOldDate != "") {
      oldDate = form.memoryOldDate.split(" ")[0];
      oldVersion = form.memoryOldDate.split(" ")[1].split("V")[1];
    }
    await dispatchDeepMemoryDataCreadOld(store, {
      project: this.localProject,
      type: "obj",
      date: date,
      version: version,
      scene: form.memoryScene == "" ? "" : Number(form.memoryScene),
      device: form.memoryDevice == "" ? "" : Number(form.memoryDevice),
      inside_scene: form.memorySubscene,
      depth: row.depth,
      old_date: oldDate,
      old_version: oldVersion,
      old_scene: form.memoryOldScene == "" ? "" : Number(form.memoryOldScene),
      old_device:
        form.memoryOldDevice == "" ? "" : Number(form.memoryOldDevice),
      old_inside_scene: form.memoryOldSubscene,
      name: row.name,
    });

    await setTimeout(() => {
      resolve(this.deepMemreportDataCreadOld);
    }, 1000);
  }
  public convertDateTime(dateStr) {
    const dateArr = dateStr.split(" ");
    const date = dateArr[0].replace("2023", "2023-11").replace("11", "11-24");
    const timeArr = dateArr[1].split(":");
    const time = timeArr
      .slice(0, 2)
      .concat(timeArr.slice(2).replace("59", "99"));
    return `${date} ${time.join(":")}`;
  }
  public formatDate(date, fmt) {
    if (!date) {
      return "";
    }
    console.log(date);
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        (date?.getFullYear() + "").substr(4 - RegExp.$1.length)
      );
    }
    let o = {
      "M+": date.getMonth() + 1,
      "d+": date.getDate(),
      "h+": date.getHours(),
      "m+": date.getMinutes(),
      "s+": date.getSeconds(),
    };
    for (let k in o) {
      if (new RegExp(`(${k})`).test(fmt)) {
        let str = o[k] + "";
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length === 1 ? str : this.padLeftZero(str)
        );
      }
    }
    console.log(fmt);
    return fmt;
  }
  public padLeftZero(str) {
    return ("00" + str).substr(str.length);
  }
  public llmLoading = false;
  public activeName = 0;
  public setList = [];
  public async tabsChange(i) {
    if (i != 3) {
      this.tabsdis = true;
      this.testLoading = true;
      this.uObjectLoading = true;
      this.uObjectTrendLoading = true;
      let form: any = {};
      form = this.tabsData[i].form;
      this.course_input = "";
      let type = this.type(i);
      this.currentPage = 1;
      this.page = 1;
      this.size = 10;
      this.oreder = "-size";
      this.nameList = [];
      form.type = "";
      this.tableMerShow(this.tableThead(form.type));
      form.inputValue = "";
      (form.date = []),
        (form.subScene = []),
        (form.testDevice = []),
        (form.testScene = []),
        (form.memoryDate = ""),
        (form.memoryDevice = ""),
        (form.memoryScene = ""),
        (form.memorySubscene = ""),
        (form.memoryOldDate = ""),
        (form.memoryOldDevice = ""),
        (form.memoryOldScene = ""),
        (form.memoryOldSubscene = ""),
        (this.leftAllTable = []);
      this.cilList = [];
      this.num = -1;
      this.changeList = [];

      await dispatchDeepMemoryDeviceOptions(store, {
        project: this.localProject,
      });
      // await dispatchDeepMemorySceneOptions(store, {
      //   project: this.localProject,
      // });
      await this.deviceOptions;
      if (this.$route.query.device) {
        form.device = this.deviceOptions.filter(
          (v) => v.device_id == this.$route.query.device
        )[0].device_id;
      } else {
        if (
          this.deviceOptions.filter((v) => v.device_id == 4788)[0]?.device_id
        ) {
          form.device = this.deviceOptions.filter(
            (v) => v.device_id == 4788
          )[0]?.device_id;
        } else {
          form.device = this.deviceOptions[0].device_id;
        }
        this.$router.push({
          query: { ...this.$route.query, device: Number(form.device) },
        });
      }

      // form.device = readGetDeepMemoryDeviceOption(store)[0].device_id;
      await dispatchDeepMemorySceneOptions(store, {
        project: this.localProject,
        device_id: form.device,
      });
      const endDate = new Date();
      const startDate = new Date();
      startDate.setDate(startDate.getDate() - 14);
      form.pick = [startDate, endDate];
      form.scene = readGetDeepMemorySceneOption(store)[0].scene_id;
      await dispatchDeepMemoryTrend(store, {
        project: this.localProject,
        device_id: Number(form.device),
        scene_id: Number(form.scene),
        type: type,
        start: dateConversion(form.pick[0]),
        end: this.formatDate(form.pick[1], "yyyy-MM-dd 23:59:59"),
      });
      if (this.memoryTrend?.memory.length > 0) {
        this.echartShow = false;
        this.echartShow = true;
        await this.$nextTick(() => {
          this.drawMemory(i);
        });
      }
      await dispatchDeepMemoryDateOptions(store, {
        project: this.localProject,
      });
      if (type != "memreport") {
        await dispatchDeepMemorySubSceneOptions(store, {
          project: this.localProject,
          type: type,
        });
      }

      // 默认
      // this.form.date=readGetDeepMemoryDateOption(store)[0]
      // this.form.testDevice=readGetDeepMemoryDeviceOption(store)[0].device_id
      // this.form.testScene=readGetDeepMemorySceneOption(store)[0].scene_id
      // this.form.subScene=readGetDeepMemorySubsceneOption(store)[0].scene
      this.tableShow = false;
      await dispatchDeepMemoryRecordList(store, {
        project: this.localProject,
        date_version: "",
        device_id: "",
        scene_id: "",
        sub_scene: "",
        page: 1,
        size: 10,
        type: type,
      });
      this.tableShow = true;
      this.tabsdis = false;
      this.testLoading = false;
      if (type === "memreport") {
        let item = this.recondList.list[0];
        this.look_name =
          item.date_version + "-" + item.device + "-" + item.scene;
        form.memoryDevice = this.deviceOptions.filter(
          (v) => v.device_id__model__name === item.device
        )[0].device_id;
        form.memoryScene = this.sceneOptions.filter(
          (v) => v.scene_id__chinese == item.scene
        )[0].scene_id;
        form.memoryDate = item.params.date_version;
        form.memoryOldDate = item.old_params.date_version;
        form.memorySubscene = item.sub_scene;
        form.memoryOldDevice = item.old_params.device_id;
        form.memoryOldScene = item.old_params.scene_id;
        form.memoryOldSubscene = item.old_params.sub_scene;
        await dispatchDeepMemoryCircleChart(store, {
          project: this.localProject,
          date: item.params.date,
          device_id: Number(item.params.device_id),
          scene_id: Number(item.params.scene_id),
          sub_scene: item.params.sub_scene ? item.params.sub_scene : "",
          version: item.params.game_version,
          old_date: item.old_params.date,
          old_device_id: Number(item.old_params.device_id),
          old_scene_id: Number(item.old_params.scene_id),
          old_sub_scene: item.old_params.sub_scene
            ? item.old_params.sub_scene
            : "",
          old_version: item.old_params.game_version,
          type: type,
        });
        await this.cilcrt;
        if (this.localProject == 12 && i == 0) {
          await dispatchDeepMemoryUobject(store, {
            project: this.localProject,
            date: item.params.date,
            device_id: Number(item.params.device_id),
            scene_id: Number(item.params.scene_id),
            sub_scene: item.params.sub_scene ? item.params.sub_scene : "",
            version: item.params.game_version,
            old_date: item.old_params.date,
            old_device_id: Number(item.old_params.device_id),
            old_scene_id: Number(item.old_params.scene_id),
            old_sub_scene: item.old_params.sub_scene
              ? item.old_params.sub_scene
              : "",
            old_version: item.old_params.game_version,
          });
          this.objectName = "first";
          await dispatchDeepMemoryUobjectTrend(store, {
            project: this.localProject,

            device_id: Number(item.params.device_id),
            scene_id: Number(item.params.scene_id),
          });

          this.drawObjcetsizeTrend(item.device, item.scene);
          this.uObjectTrendLoading = false;
          this.uObjectLoading = false;
        }
        await this.drawModular(this.activeName);
        this.nameList = this.cilcrt.map((v) => v.name);
        if (this.nameList.indexOf("All") != -1) {
          this.nameList.splice(this.nameList.indexOf("All"), 1);
        }
        form.type = this.nameList[0];
        this.tableMerShow(this.tableThead(form.type));
        this.size = 10;
        this.page = 1;
        await dispatchDeepMemreportData(store, {
          project: this.localProject,
          date: item.params.date,
          device_id: Number(item.params.device_id),
          scene_id: Number(item.params.scene_id),
          sub_scene: item.params.sub_scene ? item.params.sub_scene : "",
          version: item.params.game_version,
          old_date: item.old_params.date,
          old_device_id: Number(item.old_params.device_id),
          old_scene_id: Number(item.old_params.scene_id),
          old_sub_scene: item.old_params.sub_scene
            ? item.old_params.sub_scene
            : "",
          old_version: item.old_params.game_version,
          class_name: form.type,
          search: this.course_input,
          page: this.page,
          size: this.size,
          order: "-size",
        });
        this.oreder = "-size";
        this.id_test = this.deepMemreportData.id_test;
        this.old_test = this.deepMemreportData.old_test;
      }
    } else {
      this.llmLoading = true;
      if (!this.setList.includes("3")) {
        await dispatchDeepMemoryLlmList(store, {
          project: this.localProject,
        });
        this.setList.push(i);
      }
      this.llmLoading = false;
    }
  }
  public objectName = "";
  public async recordSearch(i) {
    let form: any = {};
    form = this.tabsData[i].form;
    let type = this.type(i);
    let date = "";
    let version = "";
    let oldDate = "";
    let oldVersion = "";
    this.page = 1;
    this.size = 10;
    if (form.memoryDate != "") {
      date = form.memoryDate.split(" ")[0];
      version = form.memoryDate.split(" ")[1].split("V")[1];
    }
    if (form.memoryOldDate != "") {
      oldDate = form.memoryOldDate.split(" ")[0];
      oldVersion = form.memoryOldDate.split(" ")[1].split("V")[1];
    }
    await dispatchDeepMemreportData(store, {
      project: this.localProject,
      date: date,
      device_id: Number(form.memoryDevice),
      scene_id: Number(form.memoryScene),
      sub_scene: "",
      version: version,
      old_date: oldDate,
      old_device_id: Number(form.memoryOldDevice),
      old_scene_id: Number(form.memoryOldScene),
      old_sub_scene: "",
      old_version: oldVersion,
      class_name: form.type,
      search: this.course_input,
      page: this.page,
      size: this.size,
      order: this.oreder,
    });
    this.id_test = this.deepMemreportData.id_test;
    this.old_test = this.deepMemreportData.old_test;
  }
  public async trendChange(value, form, i) {
    // let form: any = {};
    // form = this.tabsData[i].form;
    let type = this.type(i);
    if (value === "device") {
      await dispatchDeepMemorySceneOptions(store, {
        project: this.localProject,
        device_id: form.device,
      });
      this.$router.push({
        query: { ...this.$route.query, device: form.device },
      });
      form.scene = readGetDeepMemorySceneOption(store)[0].scene_id;
    }
    const endDate = new Date();
    const startDate = new Date();
    startDate.setDate(startDate.getDate() - 14);
    form.pick = [startDate, endDate];
    await dispatchDeepMemoryTrend(store, {
      project: this.localProject,
      device_id: Number(form.device),
      scene_id: Number(form.scene),
      type: type,
      start: dateConversion(form.pick[0]),
      end: this.formatDate(form.pick[1], "yyyy-MM-dd 23:59:59"),
    });
    if (this.memoryTrend.memory.length > 0) {
      await this.$nextTick(() => {
        this.drawMemory(i);
      });
    }
  }
  public async pickChange(form, i) {
    let type = this.type(i);
    await dispatchDeepMemoryTrend(store, {
      project: this.localProject,
      device_id: Number(form.device),
      scene_id: Number(form.scene),
      type: type,
      start: dateConversion(form.pick[0]),
      end: this.formatDate(form.pick[1], "yyyy-MM-dd 23:59:59"),
    });
    if (this.memoryTrend.memory.length > 0) {
      await this.$nextTick(() => {
        this.drawMemory(i);
      });
    }
  }
  public testLoading = false;
  public async testChange(form, i) {
    this.testLoading = true;
    // let form: any = {};
    // form = this.tabsData[i].form;
    let type = this.type(i);
    await dispatchDeepMemoryRecordList(store, {
      project: this.localProject,
      date_version: form.date,
      device_id: form.testDevice,
      scene_id: form.testScene,
      sub_scene: form.subScene,
      page: 1,
      size: 10,
      type: type,
    });
    this.testLoading = false;
  }
  public async handleCurrentChange(form, i) {
    this.testLoading = true;

    let type = this.type(i);
    await dispatchDeepMemoryRecordList(store, {
      project: this.localProject,
      date_version: form.date,
      device_id: form.testDevice,
      scene_id: form.testScene,
      sub_scene: form.subScene,
      page: this.currentPage,
      size: 10,
      type: type,
    });
    this.testLoading = false;
  }
  public course_input = "";
  public async handleCurrentChange1(form, i) {
    let type = this.type(i);
    let date = "";
    let version = "";
    let oldDate = "";
    let oldVersion = "";
    if (form.memoryDate != "") {
      date = form.memoryDate.split(" ")[0];
      version = form.memoryDate.split(" ")[1].split("V")[1];
    }
    if (form.memoryOldDate != "") {
      oldDate = form.memoryOldDate.split(" ")[0];
      oldVersion = form.memoryOldDate.split(" ")[1].split("V")[1];
    }
    await dispatchDeepMemreportData(store, {
      project: this.localProject,
      date: date,
      device_id: Number(form.memoryDevice),
      scene_id: Number(form.memoryScene),
      sub_scene: "",
      version: version,
      old_date: oldDate,
      old_device_id: Number(form.memoryOldDevice),
      old_scene_id: Number(form.memoryOldScene),
      old_sub_scene: "",
      old_version: oldVersion,
      class_name: form.type,
      search: this.course_input,
      page: this.page,
      size: this.size,
      order: this.oreder,
    });
    this.id_test = this.deepMemreportData.id_test;
    this.old_test = this.deepMemreportData.old_test;
  }
  public page = 1;
  public size = 10;
  public com_num_color(item) {
    if (String(item)?.indexOf("-") != -1) {
      return "#00b050";
    }
    if (String(item) == "0") {
      return "#606266";
    } else {
      return "red";
    }
  }
  public get deviceOptions() {
    this.MemoryData.deviceList = readGetDeepMemoryDeviceOption(store);

    return this.MemoryData.deviceList;
  }
  public get sceneOptions() {
    this.MemoryData.sceneList = readGetDeepMemorySceneOption(store);
    return this.MemoryData.sceneList;
  }
  public get dateOptions() {
    this.MemoryData.dateList = readGetDeepMemoryDateOption(store);
    return this.MemoryData.dateList;
  }
  public get subscneOptions() {
    this.MemoryData.subsceneList = readGetDeepMemorySubsceneOption(store);
    return this.MemoryData.subsceneList;
  }
  public get recondList() {
    this.MemoryData.recondList = readGetDeepMemoryRecondList(store);
    // this.MemoryData.recondList?.list.forEach(v=>{
    //   if(v.sub_scene==undefined){
    //     return v.sub_scene=''
    //   }
    // })
    // console.log(this.MemoryData.recondList)
    return this.MemoryData.recondList;
  }
  public tableShow = true;

  public get memoryTrend() {
    return readGetDeepMemoryTrend(store);
  }

  public b(i) {
    console.log(i);
  }
  public async drawObjcetsizeTrend(deivce, scene) {
    this.object_device = deivce;
    this.object_scene = scene;
    let data = [];
    this.objectTrend?.module_list.forEach((v, index) => {
      data.push({
        name: v,
        type: "line",
        symbol: "circle", //拐点设置为实心
        smooth: true, // 平滑曲线
        itemStyle: {
          normal: {
            label: {
              // show: this.getFPS_RawData.device_names.length <= 3 ? true : false,
              show: true,
            },
          },
        },
        data: this.objectTrend?.size[index],
      });
    });

    let performance_line: any = document.getElementById("objectSize");
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);

    contrastChart.setOption({
      tooltip: {
        trigger: "axis",
        confine: true,
      },
      title: {
        left: "center",

        text: deivce + scene,
      },
      legend: {
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      yAxis: {
        type: "value",
        name: "MB",
        //  nameLocation: "top",
        // 坐标轴名称与轴线之间的距离。
        // nameGap: 35,
        // nameRotate: 90,
        axisTick: false,
        //左侧线
        // axisLine: {
        //   show: true,
        // },
        //  splitLine: {
        //   show: true,
        // },
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "15%",
        right: "4%",
        containLabel: true,
      },
      animation: false,
      xAxis: {
        type: "category",
        data: this.objectTrend?.date_list,
      },

      series: data,
    });
  }
  public handleClick_object() {
    if (this.objectName == "Second") {
      this.uObjectTrendLoading = true;
      this.$nextTick(() => {
        this.drawObjcetcountTrend();
      });
      this.uObjectTrendLoading = false;
    }
  }
  public async drawObjcetcountTrend() {
    let data = [];
    this.objectTrend.module_list.forEach((v, index) => {
      data.push({
        name: v,
        type: "line",
        symbol: "circle", //拐点设置为实心
        smooth: true, // 平滑曲线
        itemStyle: {
          normal: {
            label: {
              // show: this.getFPS_RawData.device_names.length <= 3 ? true : false,
              show: true,
            },
          },
        },
        data: this.objectTrend.count[index],
      });
    });

    let performance_line: any = document.getElementById("objectCount");
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);

    contrastChart.setOption({
      tooltip: {
        trigger: "axis",
        confine: true,
      },
      title: {
        left: "center",

        text: this.object_device + this.object_scene,
      },
      legend: {
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      yAxis: {
        type: "value",
        name: "",
        //  nameLocation: "top",
        // 坐标轴名称与轴线之间的距离。
        // nameGap: 35,
        // nameRotate: 90,
        axisTick: false,
        //左侧线
        // axisLine: {
        //   show: true,
        // },
        //  splitLine: {
        //   show: true,
        // },
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "15%",
        right: "4%",
        containLabel: true,
      },
      animation: false,
      xAxis: {
        type: "category",
        data: this.objectTrend.date_list,
      },

      series: data,
    });
  }
  public async mounted() {
    this.testLoading = true;
    this.uObjectLoading = true;
    this.uObjectTrendLoading = true;
    this.objectName = "first";
    let type = "";
    let i = 0;
    if (this.localProject == 34) {
      type = this.type(this.activeName);
      i = 1;
    } else {
      type = this.type(this.activeName);
      i = 0;
    }

    await dispatchDeepMemoryDeviceOptions(store, {
      project: this.localProject,
    });
    await this.deviceOptions;

    const defaultOption = this.deviceOptions.find(item => item.device_id__model__name.includes('J200')) || this.deviceOptions[0]
    this.tabsData[i].form.testDevice = [defaultOption?.device_id]
    

    if (this.$route.query.device) {
      this.tabsData[i].form.device = this.deviceOptions.filter(
        (v) => v.device_id == this.$route.query.device
      )[0].device_id;
    } else {
      if (this.deviceOptions.filter((v) => v.device_id == 4788)[0]?.device_id) {
        this.tabsData[i].form.device = this.deviceOptions.filter(
          (v) => v.device_id == 4788
        )[0]?.device_id;
      } else {
        this.tabsData[i].form.device = this.deviceOptions[0].device_id;
      }
      this.$router.push({
        query: {
          ...this.$route.query,
          device: Number(this.tabsData[i].form.device),
        },
      });
    }

    await dispatchDeepMemorySceneOptions(store, {
      project: this.localProject,
      device_id: this.tabsData[i].form.device,
    });
    this.tabsData[i].form.scene = readGetDeepMemorySceneOption(
      store
    )[0]?.scene_id;
    const endDate = new Date();
    const startDate = new Date();
    startDate.setDate(startDate.getDate() - 14);
    this.tabsData[i].form.pick = [startDate, endDate];

    await dispatchDeepMemoryTrend(store, {
      project: this.localProject,
      device_id: Number(this.tabsData[i].form.device),
      scene_id: Number(this.tabsData[i].form.scene),
      type: type,
      start: dateConversion(this.tabsData[i].form.pick[0]),
      end: this.formatDate(
        this.tabsData[i].form.pick[1],
        "yyyy-MM-dd 23:59:59"
      ),
    });
    if (this.memoryTrend?.memory.length > 0) {
      await this.$nextTick(() => {
        this.drawMemory("0");
      });
    }
    await dispatchDeepMemoryDateOptions(store, {
      project: this.localProject,
    });
    if (type !== "memreport") {
      await dispatchDeepMemorySubSceneOptions(store, {
        project: this.localProject,
        type: type,
      });
    }
    this.tableMerShow(this.tableThead(""));

    // 默认
    // this.form.date=readGetDeepMemoryDateOption(store)[0]
    // this.form.testDevice=readGetDeepMemoryDeviceOption(store)[0].device_id
    // this.form.testScene=readGetDeepMemorySceneOption(store)[0].scene_id
    // this.form.subScene=readGetDeepMemorySubsceneOption(store)[0].scene
    await dispatchDeepMemoryRecordList(store, {
      project: this.localProject,
      date_version: "",
      device_id: "",
      scene_id: "",
      sub_scene: "",
      page: 1,
      size: 10,
      type: type,
    });

    this.tabsdis = false;
    this.testLoading = false;

    if (type == "memreport") {
      let form: any = {};
      form = this.tabsData[this.activeName].form;

      let item = this.recondList.list[0];
      this.look_name = item.date_version + "-" + item.device + "-" + item.scene;
      form.memoryDevice = this.deviceOptions.filter(
        (v) => v.device_id__model__name === item.device
      )[0].device_id;
      form.memoryScene = this.sceneOptions.filter(
        (v) => v.scene_id__chinese == item.scene
      )[0].scene_id;
      form.memoryDate = item.params.date_version;
      form.memoryOldDate = item.old_params.date_version;
      form.memorySubscene = item.sub_scene;
      form.memoryOldDevice = item.old_params.device_id;
      form.memoryOldScene = item.old_params.scene_id;
      form.memoryOldSubscene = item.old_params.sub_scene;
      await dispatchDeepMemoryCircleChart(store, {
        project: this.localProject,
        date: item.params.date,
        device_id: Number(item.params.device_id),
        scene_id: Number(item.params.scene_id),
        sub_scene: item.params.sub_scene ? item.params.sub_scene : "",
        version: item.params.game_version,
        old_date: item.old_params.date,
        old_device_id: Number(item.old_params.device_id),
        old_scene_id: Number(item.old_params.scene_id),
        old_sub_scene: item.old_params.sub_scene
          ? item.old_params.sub_scene
          : "",
        old_version: item.old_params.game_version,
        type: type,
      });
      await this.cilcrt;
      if (this.localProject == 12) {
        await dispatchDeepMemoryUobject(store, {
          project: this.localProject,
          date: item.params.date,
          device_id: Number(item.params.device_id),
          scene_id: Number(item.params.scene_id),
          sub_scene: item.params.sub_scene ? item.params.sub_scene : "",
          version: item.params.game_version,
          old_date: item.old_params.date,
          old_device_id: Number(item.old_params.device_id),
          old_scene_id: Number(item.old_params.scene_id),
          old_sub_scene: item.old_params.sub_scene
            ? item.old_params.sub_scene
            : "",
          old_version: item.old_params.game_version,
        });
        this.uObjectLoading = false;
        await dispatchDeepMemoryUobjectTrend(store, {
          project: this.localProject,

          device_id: Number(item.params.device_id),
          scene_id: Number(item.params.scene_id),
        });
        this.drawObjcetsizeTrend(item.device, item.scene);
        this.uObjectTrendLoading = false;
      }

      await this.drawModular(this.activeName);
      this.nameList = this.cilcrt.map((v) => v.name);
      if (this.nameList.indexOf("All") != -1) {
        this.nameList.splice(this.nameList.indexOf("All"), 1);
      }
      form.type = this.nameList[0];
      this.tableMerShow(this.tableThead(form.type));

      this.size = 10;
      this.page = 1;
      await dispatchDeepMemreportData(store, {
        project: this.localProject,
        date: item.params.date,
        device_id: Number(item.params.device_id),
        scene_id: Number(item.params.scene_id),
        sub_scene: item.params.sub_scene ? item.params.sub_scene : "",
        version: item.params.game_version,
        old_date: item.old_params.date,
        old_device_id: Number(item.old_params.device_id),
        old_scene_id: Number(item.old_params.scene_id),
        old_sub_scene: item.old_params.sub_scene
          ? item.old_params.sub_scene
          : "",
        old_version: item.old_params.game_version,
        class_name: form.type,
        search: this.course_input,
        page: this.page,
        size: this.size,
        order: "-size",
      });
      this.oreder = "-size";
      this.id_test = this.deepMemreportData.id_test;
      this.old_test = this.deepMemreportData.old_test;
    }
  }
  public deviationColor(item: any) {
    if (item) {
      if (String(item).indexOf("+") != -1) {
        return "red";
      }
      if (String(item).indexOf("-") != -1) {
        return "#00b050";
      }
    }
  }
  public sizeCompany(item) {
    if (String(item) != "") {
      if (Number(item) < 1024) {
        return String(item) + "K";
      }
      if (Number(item) >= 1024 && Number(item) < 1024 * 1024) {
        return (Number(item) / 1024).toFixed(1) + "M";
      }
      if (Number(item) >= 1024 * 1024) {
        return (Number(item) / 1024 / 1024).toFixed(1) + "G";
      }
    } else {
      return "";
    }
  }

  public tableThead(item) {
    let list = [];
    if (item == "") {
      list = [];
    }

    if (
      item == "RHI" ||
      item == "Particle" ||
      item == "StaticMesh" ||
      item == "SkeletalMesh" ||
      item == "StaticMeshComponent" ||
      item == "Level"
    ) {
      list = ["name", "size"];
    }
    if (item === "RenderTarget") {
      list = ["name", "size", "resolution", "format", "mips"];
    }
    if (item == "Animation") {
      list = [
        "name",
        "size",
        "type",
        "length",
        "rate_scale",
        "num_curves",
        "translation_format",
        "rotation_format",
        "scale_format",
      ];
    }

    if (item === "Texture") {
      list = [
        "name",
        "size",
        "resolution",
        "format",
        "size_ondisk",
        "resolution_ondisk",
        "lod_group",
      ];
    }
    if (
      item == "StaticMesh" ||
      item == "SkeletalMesh" ||
      item == "StaticMeshComponent" ||
      item == "Level"
    ) {
      list.push("res_exc_size");
    }
    return list;
  }
  public async onSearch(form, i) {
    let type = this.type(i);
    let date = "";
    let version = "";
    let oldDate = "";
    let oldVersion = "";
    if (form.memoryDate != "") {
      date = form.memoryDate.split(" ")[0];
      version = form.memoryDate.split(" ")[1].split("V")[1];
    }
    if (form.memoryOldDate != "") {
      oldDate = form.memoryOldDate.split(" ")[0];
      oldVersion = form.memoryOldDate.split(" ")[1].split("V")[1];
    }
    await dispatchDeepMemreportData(store, {
      project: this.localProject,
      date: date,
      device_id: Number(form.memoryDevice),
      scene_id: Number(form.memoryScene),
      sub_scene: "",
      version: version,
      old_date: oldDate,
      old_device_id: Number(form.memoryOldDevice),
      old_scene_id: Number(form.memoryOldScene),
      old_sub_scene: "",
      old_version: oldVersion,
      class_name: form.type,
      search: this.course_input,
      page: this.page,
      size: this.size,
      order: this.oreder,
    });
    this.id_test = this.deepMemreportData.id_test;
    this.old_test = this.deepMemreportData.old_test;
  }
  public deviation(item: any) {
    if (item) {
      if (Math.abs(Number(item)) < 1024) {
        return "(" + String(item) + "K)";
      }
      if (Math.abs(Number(item)) > 1024) {
        if (item.indexOf("+") != -1) {
          return "(+" + String((Number(item) / 1024).toFixed(1)) + "M)";
        } else if (String(item).indexOf("-") != -1) {
          return "(" + String((Number(item) / 1024).toFixed(1)) + "M)";
        }
      }
    } else {
      return "";
    }
  }

  public tableList = [];
  public tableList1 = [];

  public cilList = [];
  public get cilcrt() {
    this.cilList =
      JSON.stringify(readGetDeepMemoryCircleChart(store)) === "{}"
        ? []
        : readGetDeepMemoryCircleChart(store);
    let num = 0;
    this.cilList.forEach((v) => {
      if (v.name != "All") {
        num += v.value;
      }
    });
    this.cilList.forEach((v) => {
      v.rate = (v.value / num) * 100;
    });

    return this.cilList;
  }
  public nameList = [];
  public leftAllTable = [];
  public drawModular(index) {
    let cilData = this.cilcrt;

    let performance_line: any = document.getElementById(
      "modular" + String(index)
    ) as HTMLElement;

    var contrastChart = echarts.init(performance_line);
    let type = this.type(index);
    if (index == 0 && this.localProject != 34) {
      let form: any = {};
      form = this.tabsData[index].form;

      let date = "";
      let version = "";
      let oldDate = "";
      let oldVersion = "";
      if (form.memoryDate != "") {
        date = form.memoryDate.split(" ")[0];
        version = form.memoryDate.split(" ")[1].split("V")[1];
      }
      if (form.memoryOldDate != "") {
        oldDate = form.memoryOldDate.split(" ")[0];
        oldVersion = form.memoryOldDate.split(" ")[1].split("V")[1];
      }
      contrastChart.on("click", (params) => {
        form.type = params.name;
        this.size = 10;
        this.page = 1;
        this.course_input = "";
        dispatchDeepMemreportData(store, {
          project: this.localProject,
          date: date,
          device_id: Number(form.memoryDevice),
          scene_id: Number(form.memoryScene),
          sub_scene: "",
          version: version,
          old_date: oldDate,
          old_device_id: Number(form.memoryOldDevice),
          old_scene_id: Number(form.memoryOldScene),
          old_sub_scene: "",
          old_version: oldVersion,
          class_name: form.type,
          search: this.course_input,
          page: this.page,
          size: this.size,
          order: "-size",
        }).then((res) => {
          this.id_test = this.deepMemreportData.id_test;
          this.old_test = this.deepMemreportData.old_test;
        });
        this.oreder = "-size";
        this.$nextTick(() => {
          (this.$refs.tableList as any).sort("size", "descending");
        });
      });
    }

    let legend = {};
    // if (type == "memreport") {
    //   legend = {
    //     orient: "vertical", //图例的布局，水平布局、垂直布局
    //     type: "scroll",

    //     left: "50%",
    //     top: "middle",
    //     icon: "circle",
    //     itemWidth: 8, //图例宽度
    //     itemHeight: 8, //图例高度
    //     textStyle: {
    //       //图例字体样式
    //       color: "#000",
    //       fontSize: 18,
    //       fontFamily: "微软雅黑",
    //     },
    //     formatter: function (labelName) {
    //       for (
    //         let index = 0;
    //         index < cilData.filter((v) => v.name != "All").length;
    //         index++
    //       ) {
    //         const { name, value, change, rate } = cilData.filter(
    //           (v) => v.name != "All"
    //         )[index];
    //         if (
    //           cilData.filter((v) => v.name != "All")[index].name == labelName
    //         ) {
    //           return `${labelName}  ${rate.toFixed(2)}%   ${value + "M"}   ${
    //             String(change).indexOf("-") != -1 || change == 0 ? "" : "+"
    //           }${change + "M"}`;
    //         }
    //       }
    //     },
    //   };
    // } else {
    //   legend = "";
    // }
    contrastChart.setOption({
      tooltip: {
        trigger: "item",
        position: "top",
        textStyle: {
          fontWeight: "bold", // 加粗字体
        },
      },
      legend: "",

      series: [
        {
          type: "pie",
          radius: "80%",
          center: ["50%", "50%"],
          data: cilData.filter((v) => v.name != "All"),
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
          itemStyle: {
            normal: {
              label: {
                show: true,
                formatter: "{d}%",
                position: "inside",
                color: "#fff",
                fontWeight: "bold", // 加粗字体
              },
              labelLine: { show: true },
            },
          },
        },
      ],
    });
  }
  public async downloadCsv() {
    const response_data = dispatchDeepMemoryDownLoad(store, {
      project: this.localProject,
      id_test: this.id_test,
      old_test: this.old_test,
    });
    response_data.then((value) => {
      // console.log(value);
      var elink = document.createElement("a");
      elink.download = this.look_name + ".xls";
      elink.style.display = "none";
      var blob = new Blob([value], { type: "application/vnd.ms-excel" });

      elink.href = URL.createObjectURL(blob);
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    });
  }
  public drawMemory(index) {
    let series = [];
    this.memoryTrend.scene_list.forEach((v, index) => {
      series.push({
        name: v,
        type: "line",
        symbol: "circle",
        data: this.memoryTrend.memory[index],
      });
    });

    let performance_line: any = document.getElementById(
      "memory" + String(index)
    );
    echarts.dispose(performance_line);

    var contrastChart = echarts.init(performance_line);
    contrastChart.setOption({
      tooltip: {
        trigger: "axis",
        confine: true,
        //       formatter: function (params){
        //       var relVal = params[0].name
        //   for (var i = 0, l = params.length; i < l; i++) {
        //     relVal += '<br/>' + params[i].marker +  '<span style="margin-left:10px;margin-right:10px">'+params[i].seriesName+'</span>'+params[i].value + 'M'
        //   }
        //   return relVal
        // }
      },
      title: {
        left: "center",
        text:
          this.deviceOptions.filter(
            (v) => v.device_id == this.tabsData[index].form.device
          )[0].device_id__model__name +
          this.sceneOptions.filter(
            (v) => v.scene_id == this.tabsData[index].form.scene
          )[0].scene_id__chinese,
      },
      legend: {
        type: "scroll",
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      yAxis: {
        type: "value",
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "20%",
        right: "4%",
        containLabel: true,
      },
      animation: false,
      xAxis: {
        type: "category",
        data: this.memoryTrend.date_list,
      },

      series: series,
    });
  }
}
